var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
Ce module gère les sorties de stcoks et les retours pour un job donné.
Pour chaque job il y a une liste de pièces (PartsStock > partRequirement)
Pour chaque pièce il peut avoir des lignes de sortie de stock et de retour en stock (StockTransaction).
Une action de sortie de stock ou de retour en stock peut comporter plusieurs pièces (StockTransaction  comportant un order)
Chaque pièce doit mémoriser les lignes de transaction sur le stock (StockTransaction : input ou back).
La liste affichée dans l'UI est contenue dans PartsTransact
*/
import { EventEmitter, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatSidenav } from '@angular/material';
import { TranslateService } from '../../../../../../services/translate.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UserService } from '../../../../../../services/user.service';
import { WksCentralService } from '../../../../services/wks-central.service';
import { PartsStock, WorkInputEvent } from '../../../../models/wks-works.model';
import { ParamPartsSuppliesModel, PartsRequirement, PartTransaction, StockTransaction } from '../../../../models/wks-param.model';
import { RessourcesService } from '../../../../../../job/common/services/ressources.service';
import { DataUpstream } from '../../../../models/wks-common.model';
import { ModalCommonComponent } from '../../../../../common/components/modal-common/modal-common.component';
import { CommonMethods } from '../../../../../../job/common/tools/commonMethods';
import { WksApisService } from '../../../../services/wks-apis.service';
export class PartsSuppliesMovementComponent {
    constructor(_userService, _translateService, _wksCentralService, _ressourcesService, modalService, _dialog, _apiService) {
        this._userService = _userService;
        this._translateService = _translateService;
        this._wksCentralService = _wksCentralService;
        this._ressourcesService = _ressourcesService;
        this.modalService = modalService;
        this._dialog = _dialog;
        this._apiService = _apiService;
        this.dataOut = new EventEmitter();
        this.onDestroy = new Subject();
        this.configModal = {
            class: 'modal-dialog-centered customWidthModal',
            backdrop: true,
            ignoreBackdropClick: true,
            animated: false,
        };
    }
    ngOnChanges(changes) {
        const listKey = Object.keys(changes);
        for (const propName of listKey) {
            if (changes.hasOwnProperty(propName)) {
                switch (propName) {
                    case 'partsStock': {
                        const partsStock = changes['partsStock'].currentValue;
                        this.partsStockCache = JSON.parse(JSON.stringify(partsStock));
                        break;
                    }
                    case 'idxWorkToDisplay': {
                        this.idxWorkToDisplay = changes['idxWorkToDisplay'].currentValue;
                        break;
                    }
                    case 'workId': {
                        this.workId = changes['workId'].currentValue;
                        break;
                    }
                    case 'callFrom': {
                        this.callFrom = changes['callFrom'].currentValue;
                        break;
                    }
                    case 'readOnly': {
                        this.readOnly = changes['readOnly'].currentValue;
                        break;
                    }
                    case 'readStock': {
                        this.readStock = changes['readStock'].currentValue;
                        break;
                    }
                    case 'wksEntity': {
                        this.wksEntity = changes['wksEntity'].currentValue;
                        break;
                    }
                    case 'workRef': {
                        this.workRef = changes['workRef'].currentValue;
                        break;
                    }
                } // end switch
            } // end if
        } // end loop
        this.initData();
    }
    initData() {
        if (this._userService.getUserLogged() === undefined) {
            return;
        }
        this.initAllBooleaans();
        this.settingFormats();
        this.initVariables();
        this.affectData();
        this.initializeScreen = true;
        this.displayParts = true;
        if (this.readStock) {
            this.verifyStockParts(this.workId, this.wksEntity.stdEntity);
        }
    }
    initAllBooleaans() {
        this.initializeScreen = false;
        this.displayParts = false;
        this.isOkToSave = false;
        this.isLoadingData = true;
        this.displayErrorMsg = false;
        this.sidenavCollapsed = true;
        this.isNotReferenced = false;
        // this.isRowsPartsSubjectSuspended = false;
    }
    initVariables() {
        this.rowsParts = [];
        this.dataLabelCur = [];
        this.partsTransacts = [];
        this.notReferencedList = [];
        this.dataLabelCur[0] = this._translateService.instant('brandRef');
        this.dataLabelCur[1] = this._translateService.instant('replacesReference');
        this.dataLabelCur[2] = this._translateService.instant('suppliesLabel');
        this.dataLabelCur[3] = this._translateService.instant('actionTask');
        this.dataLabelCur[4] = this._translateService.instant('billingUnit');
        this.dataLabelCur[5] = this._translateService.instant('planned_quantity');
        this.dataLabelCur[6] = this._translateService.instant('output_quantity');
        this.dataLabelCur[7] = this._translateService.instant('input_quantity');
        this.dataLabelCur[8] = this._translateService.instant('inStock');
        this.listPartsToReplace = [];
        this.labelsTabs = [];
        this.labelsTabs[0] = 'parts';
        this.labelsTabs[1] = 'backInStock';
        this.partsRequirement = [];
        this.partsRequirement = [];
    }
    settingFormats() {
        const otherData = JSON.parse(this._wksCentralService.getWksEntityCur().otherData);
        const intFormat = otherData.internationnalFormat;
        this.numberFormat = {
            locale: this._ressourcesService.getFormat(intFormat, 'numbers', 'locale'),
            minDecimal: this._ressourcesService.getFormat(intFormat, 'numbers', 'minimumFractionDigits'),
            maxDecimal: this._ressourcesService.getFormat(intFormat, 'numbers', 'maximumFractionDigits'),
            currency: this._ressourcesService.getFormat(intFormat, 'numbers', 'currency'),
        };
        this.timeFormat = this._translateService.getLocalFmt('timeFormat');
    }
    notifModifValues() {
        let isModified = false;
        if (JSON.parse(JSON.stringify(this.partsStockCache.parts)) !== JSON.parse(JSON.stringify(this.partsRequirement))) {
            this.partsStockCache.parts = this.partsRequirement;
            isModified = true;
        }
        if (isModified) {
            const event = {
                objectCur: 'works',
                action: 'validStockMovment',
                iRow: this.idxWorkToDisplay,
                partsStock: this.partsStockCache,
                inflAppli: 'wharehouseMan-waiting'
            };
            this.dataOut.emit(event);
        }
    }
    initAllParam() {
        this.wksEntity = this._wksCentralService.getWksEntityCur();
        const otherData = JSON.parse(this.wksEntity.otherData);
        const internationnalFormat = otherData.internationnalFormat;
        this.internationalsFormats = this._ressourcesService.getIntFormat(internationnalFormat);
        for (const fmtCur of this.internationalsFormats.datetime) {
            if (fmtCur.name === 'dateFormat') {
                this.dateFormat = fmtCur.value;
                this.dateFormatMoment = fmtCur.value;
                this.dateFormatMoment = this.dateFormatMoment.replace('dd', 'DD');
                this.dateFormatMoment = this.dateFormatMoment.replace('yyyy', 'YYYY');
            }
            if (fmtCur.name === 'timeFormat') {
                this.dateTimeFormat = fmtCur.value;
                this.dateTimeFormat = this.dateTimeFormat.replace('dd', 'DD');
                this.dateTimeFormat = this.dateTimeFormat.replace('yyyy', 'YYYY');
            }
        }
    }
    settingOddEven(rows) {
        let i = 0;
        for (const item of rows) {
            item.odd = this.oddEven(i);
            i++;
        }
    }
    oddEven(idx) {
        return (idx % 2 !== 0 ? true : false);
    }
    collapsedOther(idx, isCollapsed) {
        let i = 0;
        for (const item of this.rowsParts) {
            if (i === idx) {
                item.isCollapsed = isCollapsed;
                i++;
                continue;
            }
            item.isCollapsed = true;
            i++;
        }
    }
    settingListPartsToReplace(idxRow, brandRefCur) {
        this.listPartsToReplace = [];
        for (const partCur of this.partsRequirement) {
            if (partCur.brandRef === brandRefCur) {
                continue;
            }
            if (partCur.nws_order_ref !== undefined && partCur.nws_order_ref !== null && partCur.nws_order_ref !== '') {
                continue;
            }
            const labelCur = {
                label: partCur.brandRef,
                value: partCur.brandRef
            };
            this.listPartsToReplace.push(labelCur);
        }
    }
    addPart() {
        this.updateSuppliesList();
        this.openSearchModal('supplies&parts');
    }
    removePart(idxPart) {
        this.partsRequirement.splice(idxPart, 1);
        this.rowsParts.splice(idxPart, 1);
        this.settingOddEven(this.rowsParts);
        this.notifModifValues();
    }
    inputFields(origin, value, idxRow) {
        switch (origin) {
            case 'replacesReference': {
                this.partsRequirement[idxRow].replacesReference = value;
                break;
            }
        }
    }
    formatNumericField(fieldName) {
        CommonMethods.formatNumericField(fieldName, this._translateService, ['quantity', this.numberFormat.locale, this.numberFormat.minDecimal, this.numberFormat.maxDecimal]);
    }
    unformatNumericField(fieldName) {
        CommonMethods.unformatNumericField(fieldName);
    }
    numberAndDotOnly(event) {
        return CommonMethods.numberAndDotOnly(event);
    }
    handleEnter(event, fieldName, idxRow) {
        event.preventDefault(); // Empêche l'ajout automatique
        if (fieldName) {
            const input = document.getElementById(fieldName);
        }
    }
    toggleSidenav(_arg) {
        if (_arg === 'backdrop') {
            return;
        }
        if (_arg === 'close') {
            this.sidenavCollapsed = true;
            try {
                this.sidenav.close();
            }
            catch (error) {
            }
            finally { }
            return;
        }
        this.sidenavCollapsed = !this.sidenavCollapsed;
        if (this.sidenavCollapsed) {
            try {
                this.sidenav.close();
            }
            catch (error) {
            }
            finally { }
        }
        else {
            try {
                this.transactOption = _arg;
                this.initTransactions();
                this.initListParts(_arg);
                if (_arg === 'input') {
                    this.sidenavTitle = this._translateService.instant('inputStock');
                    this.sidenavButton = this._translateService.instant('inputStock');
                    this.transactType = 'input';
                }
                else {
                    this.sidenavTitle = this._translateService.instant('outputStock');
                    this.sidenavButton = this._translateService.instant('outputStock');
                    this.transactType = 'output';
                }
                this.sidenav.open();
            }
            catch (error) {
            }
            finally { }
        }
    }
    saveTransacts() {
        return __awaiter(this, void 0, void 0, function* () {
            let listParts = [];
            let transactComment = this.transactType === 'input' ? this._translateService.instant('inputStock') : this._translateService.instant('outputStock');
            transactComment = transactComment + '  ' + this.workRef;
            const date = new Date();
            const result = this.partsTransacts
                // .filter(c => eligibleBrandRef.has(c.brandRef) && c.type === contactType)
                .map(c => {
                const partsRequirement = this.partsRequirement.find(p => p.brandRef === c.brandRef);
                return {
                    brandRef: partsRequirement.brandRef,
                    transactDate: date.toISOString(),
                    transactType: this.transactType,
                    transactComment: transactComment,
                    transactStatut: 'new',
                    nws_order_id: '',
                    nws_order_ref: '',
                    nws_stock_id: partsRequirement.nws_stock_id,
                    nws_less_qty: c.outputStock,
                    nws_add_qty: c.inputStock,
                    outputStock: c.outputStock,
                    inputStock: c.inputStock,
                    paramRate: partsRequirement.nws_order_price
                };
            });
            listParts = [...result];
            let isError = false;
            for (let itemPart of listParts) {
                try {
                    itemPart = yield this.updateStock(itemPart);
                }
                catch (error) {
                    isError = true;
                    break;
                }
            }
            if (!isError) {
                this.notifModifValues();
                this.toggleSidenav('close');
            }
        });
    }
    updateStock(itemPart) {
        return new Promise((resolve, reject) => {
            let apiService = 'movementLess';
            let movementStatut = 'nws_less_qty';
            let movementStock = itemPart.outputStock;
            // movementBack
            if (this.transactType === 'input') {
                apiService = 'movementBack';
                movementStatut = 'nws_add_qty';
                movementStock = itemPart.inputStock;
            }
            const apiName = 'stockManagement';
            const toolArgs = {
                toolDatas: []
            };
            let testData = {
                key: 'toolCustomerNwsCode',
                value: this._apiService.getApiStockManagement().toolCustomerNwsCode
            };
            toolArgs.toolDatas.push(testData);
            testData = {
                key: 'toolCustomerNwsId',
                value: this._apiService.getApiStockManagement().toolCustomerNwsId
            };
            toolArgs.toolDatas.push(testData);
            let toolKeyValue = {
                key: 'product_id',
                value: itemPart.nws_stock_id,
                listValues: undefined,
                arrayValues: undefined
            };
            let jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            toolKeyValue = {
                key: 'warehouse_id',
                value: itemPart.warehouse_id,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            toolKeyValue = {
                key: 'movementcode',
                value: this._userService.getUserLogged().username,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            toolKeyValue = {
                key: 'movementlabel',
                value: itemPart.transactComment,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            toolKeyValue = {
                key: movementStatut,
                value: '' + movementStock,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            toolKeyValue = {
                key: 'nws_param_rate',
                value: '' + itemPart.paramRate,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            // nws_stock_ref
            toolKeyValue = {
                key: 'nws_stock_ref',
                value: itemPart.brandRef,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            const messageDisplay = {
                titleBox: 'saveTransactsTitle',
                messageLabel: apiName + 'Mes',
                messageArgs: [this._translateService.getTranslate(apiService), this._translateService.getTranslate('inProgress')],
                messageType: 'ERROR',
                messageDatas: undefined,
                typeDialog: 'infoProgressWks',
                actionCur: 'saveTransacts',
                progressDeterminate: false,
            };
            this.messageBoxDisplay(messageDisplay);
            this._wksCentralService.requestApis(this.wksEntity.stdEntity, apiName, apiService, toolArgs)
                .subscribe(data => {
                this.closeMatDialog();
                const toolApiResponse = data.body;
                if (toolApiResponse.statut === 'KO') {
                    this.affectResponse(toolApiResponse, 'saveTransacts', 'KO', itemPart);
                    // this.fillModel();
                    // this.notifModifValues();
                    const messageDisplay2 = {
                        titleBox: 'saveTransactsTitle',
                        messageLabel: apiName + 'Mes',
                        messageArgs: [this._translateService.getTranslate(apiService), 'KO'],
                        messageType: 'ERROR',
                        messageDatas: undefined,
                        typeDialog: 'alertWks',
                        actionCur: 'saveTransactsKO',
                        progressDeterminate: false,
                    };
                    this.messageBoxDisplay(messageDisplay2);
                }
                else {
                    const messageDisplay1 = {
                        titleBox: 'saveTransactsTitle',
                        messageLabel: apiName + 'Mes',
                        messageArgs: [this._translateService.getTranslate(apiService), 'OK'],
                        messageType: 'INFO',
                        messageDatas: undefined,
                        typeDialog: 'alertWks',
                        actionCur: 'saveTransactsOK',
                        progressDeterminate: false,
                    };
                    this.messageBoxDisplay(messageDisplay1);
                    this.affectResponse(toolApiResponse, 'saveTransacts', 'OK', itemPart);
                    this.journalizeTransact(itemPart);
                }
                resolve(itemPart);
            }, err => {
                this.closeMatDialog();
                const toolParamReturn = err.error;
                toolParamReturn.statut = err.status.toString();
                this.affectResponse(toolParamReturn, 'saveTransacts', 'KO', itemPart);
                const messageDisplay2 = {
                    titleBox: 'testApi',
                    messageLabel: apiName + 'Mes',
                    messageArgs: [this._translateService.getTranslate(apiService), 'KO'],
                    messageType: 'ERROR',
                    messageDatas: undefined,
                    typeDialog: 'alertWks',
                    actionCur: 'testApiKO',
                    progressDeterminate: false,
                };
                this.messageBoxDisplay(messageDisplay2);
                reject(itemPart);
            });
        });
    }
    removeTransacts(orderId, orderRef) {
        // let itemPart: StockTransaction = undefined;
        const result = this.partsRequirement
            .map(p => p.stockTransacts.filter(c => c.nws_order_ref === orderRef))
            .reduce((acc, val) => acc.concat(val), []);
        const itemPart = JSON.parse(JSON.stringify(result));
        itemPart.transactComment = this._translateService.instant('cancelOutputStock') + ' ' + this.workRef + ' / ' + orderRef;
        itemPart.transactStatut = 'remove';
        itemPart.transactType = this.transactType;
        let apiService = 'movementBack';
        let movementStatut = 'nws_add_qty';
        let movementStock = itemPart.outputStock;
        // backInStock annulation
        if (this.transactType === 'input') {
            apiService = 'movementLess';
            movementStatut = 'nws_less_qty';
            movementStock = itemPart.inputStock;
        }
        const apiName = 'stockManagement';
        const toolArgs = {
            toolDatas: []
        };
        let testData = {
            key: 'toolCustomerNwsCode',
            value: this._apiService.getApiStockManagement().toolCustomerNwsCode
        };
        toolArgs.toolDatas.push(testData);
        testData = {
            key: 'toolCustomerNwsId',
            value: this._apiService.getApiStockManagement().toolCustomerNwsId
        };
        toolArgs.toolDatas.push(testData);
        let toolKeyValue = {
            key: 'nws_order_id',
            value: orderId,
            listValues: undefined,
            arrayValues: undefined
        };
        let jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
        toolKeyValue = {
            key: 'nws_order_ref',
            value: orderRef,
            listValues: undefined,
            arrayValues: undefined
        };
        jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
        toolKeyValue = {
            key: 'product_id',
            value: itemPart.nws_stock_id,
            listValues: undefined,
            arrayValues: undefined
        };
        jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
        toolKeyValue = {
            key: 'warehouse_id',
            value: itemPart.warehouse_id,
            listValues: undefined,
            arrayValues: undefined
        };
        jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
        toolKeyValue = {
            key: 'movementcode',
            value: this._userService.getUserLogged().username,
            listValues: undefined,
            arrayValues: undefined
        };
        jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
        toolKeyValue = {
            key: 'movementlabel',
            value: itemPart.transactComment,
            listValues: undefined,
            arrayValues: undefined
        };
        jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
        toolKeyValue = {
            key: movementStatut,
            value: '' + movementStock,
            listValues: undefined,
            arrayValues: undefined
        };
        jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
        toolKeyValue = {
            key: 'nws_param_rate',
            value: '' + itemPart.paramRate,
            listValues: undefined,
            arrayValues: undefined
        };
        jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
        const messageDisplay = {
            titleBox: 'removeTransactsTitle',
            messageLabel: apiName + 'Mes',
            messageArgs: [this._translateService.getTranslate(apiService), this._translateService.getTranslate('inProgress')],
            messageType: 'ERROR',
            messageDatas: undefined,
            typeDialog: 'infoProgressWks',
            actionCur: 'removeTransacts',
            progressDeterminate: false,
        };
        this.messageBoxDisplay(messageDisplay);
        this._wksCentralService.requestApis(this.wksEntity.stdEntity, apiName, apiService, toolArgs)
            .subscribe(data => {
            this.closeMatDialog();
            const toolApiResponse = data.body;
            if (toolApiResponse.statut === 'KO') {
                this.affectResponse(toolApiResponse, 'removeTransacts', 'KO', itemPart);
                const messageDisplay2 = {
                    titleBox: 'removeTransactsTitle',
                    messageLabel: apiName + 'Mes',
                    messageArgs: [this._translateService.getTranslate(apiService), 'KO'],
                    messageType: 'ERROR',
                    messageDatas: undefined,
                    typeDialog: 'alertWks',
                    actionCur: 'removeTransactsKO',
                    progressDeterminate: false,
                };
                this.messageBoxDisplay(messageDisplay2);
            }
            else {
                const messageDisplay1 = {
                    titleBox: 'removeTransactsTitle',
                    messageLabel: apiName + 'Mes',
                    messageArgs: [this._translateService.getTranslate(apiService), 'OK'],
                    messageType: 'INFO',
                    messageDatas: undefined,
                    typeDialog: 'alertWks',
                    actionCur: 'removeTransactsOK',
                    progressDeterminate: false,
                };
                this.messageBoxDisplay(messageDisplay1);
                this.affectResponse(toolApiResponse, 'removeTransacts', 'OK', itemPart);
                this.journalizeTransact(itemPart);
                this.notifModifValues();
            }
        }, err => {
            this.closeMatDialog();
            const toolParamReturn = err.error;
            toolParamReturn.statut = err.status.toString();
            this.affectResponse(toolParamReturn, 'removeTransacts', 'KO', itemPart);
            const messageDisplay2 = {
                titleBox: 'testApi',
                messageLabel: apiName + 'Mes',
                messageArgs: [this._translateService.getTranslate(apiService), 'KO'],
                messageType: 'ERROR',
                messageDatas: undefined,
                typeDialog: 'alertWks',
                actionCur: 'testApiKO',
                progressDeterminate: false,
            };
            this.messageBoxDisplay(messageDisplay2);
        });
    }
    createStockProduct(idxRow) {
        return new Promise((resolve, reject) => {
            const apiService = 'create';
            const apiName = 'stockManagement';
            const toolArgs = {
                toolDatas: []
            };
            let testData = {
                key: 'toolCustomerNwsCode',
                value: this._apiService.getApiStockManagement().toolCustomerNwsCode
            };
            toolArgs.toolDatas.push(testData);
            testData = {
                key: 'toolCustomerNwsId',
                value: this._apiService.getApiStockManagement().toolCustomerNwsId
            };
            toolArgs.toolDatas.push(testData);
            let toolKeyValue = {
                key: 'nws_label',
                value: this.notReferencedList[idxRow].partSupplieLabel,
                listValues: undefined,
                arrayValues: undefined
            };
            let jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            toolKeyValue = {
                key: 'nws_id',
                value: this.notReferencedList[idxRow].partSupplieId,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            toolKeyValue = {
                key: 'brandRef',
                value: this.notReferencedList[idxRow].brandRef,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            this._apiService.requestApis(this._wksCentralService.getWksEntityCur().stdEntity, apiName, apiService, toolArgs)
                .subscribe((data) => {
                const toolApiResponse = data.body;
                if (toolApiResponse.statut === 'KO') {
                    const messageDisplay = {
                        titleBox: 'validate part & supplie',
                        messageLabel: this._translateService.instant('stock create', [this.partsRequirement[idxRow].brandRef]),
                        messageArgs: [],
                        messageType: 'ERROR',
                        messageDatas: undefined,
                        typeDialog: 'alertWks',
                        actionCur: 'create Part',
                        progressDeterminate: false,
                    };
                    this.messageBoxDisplay(messageDisplay);
                }
                else {
                    const nwsId = toolApiResponse.toolDatas[0].value;
                }
            }, err => {
            });
            resolve();
        });
    }
    affectResponse(toolApiResponse, action, statut, itemPart) {
        if (statut === 'OK') {
            let nws_movement_id;
            for (const itemData of toolApiResponse.toolDatas) {
                if (itemData.key === 'nws_movement_id') {
                    nws_movement_id = itemData.value;
                    continue;
                }
            }
            itemPart.nws_movement_id = nws_movement_id;
            if (action === 'saveTransacts') {
                let idxPart = 0;
                for (const partTransacts of this.partsTransacts) {
                    if (partTransacts.brandRef === itemPart.brandRef) {
                        this.partsTransacts[idxPart].nws_movement_id = nws_movement_id;
                        this.partsTransacts[idxPart].outputStock = itemPart.outputStock;
                        this.partsTransacts[idxPart].inputStock = itemPart.inputStock;
                        break;
                    }
                    idxPart++;
                }
            }
            let labelRef = 'NOT_RESERVED';
            if (this.transactType === 'input') {
                labelRef = 'NOT_BACK';
            }
            if (action === 'removeTransacts') {
                // this.partsTransacts = partsTransacts;
                let idxPart = 0;
                for (const partTransacts of this.partsTransacts) {
                    if (partTransacts.brandRef === itemPart.brandRef) {
                        this.partsTransacts[idxPart].nws_movement_id = nws_movement_id;
                        this.partsTransacts[idxPart].outputStock = itemPart.outputStock;
                        this.partsTransacts[idxPart].inputStock = itemPart.inputStock;
                        break;
                    }
                    idxPart++;
                }
            }
        }
    }
    getTransactDateFmt(transactDate) {
        return CommonMethods.dateToString(transactDate, 'unixM', this.timeFormat);
    }
    journalizeTransact(itemPart) {
        for (const partItem of this.partsRequirement) {
            if (partItem.brandRef === itemPart.brandRef) {
                if (partItem.stockTransacts === undefined) {
                    partItem.stockTransacts = [];
                }
                partItem.stockTransacts.push(itemPart);
                break;
            }
        }
    }
    getStockParts() {
        this.verifyStockParts(this.workId, this.wksEntity.stdEntity);
    }
    createReferences() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.notReferencedList.length === 0) {
                this.isNotReferenced = false;
                return;
            }
            let idxPart = 0;
            const messageDisplay = {
                titleBox: 'createRefStockTitle',
                messageLabel: 'createRefStockMes',
                messageArgs: [],
                messageType: 'ERROR',
                messageDatas: undefined,
                typeDialog: 'infoProgressWks',
                actionCur: 'createRef',
                progressDeterminate: false,
            };
            this.messageBoxDisplay(messageDisplay);
            for (const part of this.notReferencedList) {
                yield this.createStockProduct(idxPart);
                /*
                setTimeout(() => {
                }, 5000); // 5000 ms = 5 s
                */
                idxPart++;
            }
            this.closeMatDialog();
            this.getStockParts();
        });
    }
    getNewRowPart() {
        const partsRequirement = {
            partSupplieId: '',
            partSupplieLabel: '',
            brandRef: '',
            replacesReference: '',
            actionTask: '',
            billingUnit: '',
            quantity: 0,
            inStock: 0,
            stockStatus: 'KO',
            nws_order_ref: '',
            partAdded: true
        };
        return partsRequirement;
    }
    getRowPartAdded(rowPart) {
        const partsRequirement = {
            partSupplieId: rowPart.id,
            partSupplieLabel: rowPart.partsSuppliesLabel,
            brandRef: rowPart.brandRef,
            replacesReference: '',
            actionTask: '',
            billingUnit: (rowPart.paramUnit ? rowPart.paramUnit : 'unit'),
            quantity: 0,
            inStock: 0,
            stockStatus: 'KO',
            nws_order_ref: '',
            partAdded: true
        };
        return partsRequirement;
    }
    updateSuppliesList() {
        this.suppliesList = [];
        for (const partSupplieCur of this.partsRequirement) {
            if (!partSupplieCur.partAdded) {
                this.suppliesList.push(partSupplieCur);
            }
        }
        this.suppliesList.sort((a, b) => a.brandRef.localeCompare(b.brandRef));
        // this.suppliesList.unshift(this.getNewRowPart());
    }
    affectData() {
        this.rowsParts = [];
        for (const rowData of this.partsStockCache.parts) {
            this.rowsParts.push({ status: 'origin', odd: false, isCollapsed: true });
        }
        this.settingOddEven(this.rowsParts);
        this.partsRequirement = JSON.parse(JSON.stringify(this.partsStockCache.parts));
        this.movementsTotalization();
    }
    movementsTotalization() {
        for (const itemPart of this.partsRequirement) {
            let outputStockTmp = 0;
            let inputStockTmp = 0;
            if (itemPart.stockTransacts !== undefined) {
                for (const transactionsCur of itemPart.stockTransacts) {
                    if (transactionsCur.inputStock !== undefined) {
                        inputStockTmp += transactionsCur.inputStock;
                    }
                    if (transactionsCur.outputStock !== undefined) {
                        outputStockTmp += transactionsCur.outputStock;
                    }
                }
            }
            itemPart.inputStock = inputStockTmp;
            itemPart.outputStock = outputStockTmp;
        }
    }
    // ================================================================= transactions detail 
    removeMovement(iTransact) {
        if (this.partsTransactChoice[iTransact].outputStock > 0 && this.partsTransactChoice[iTransact].nws_order_ref !== undefined) {
            this.removeTransacts(this.partsTransactChoice[iTransact].nws_order_id, this.partsTransactChoice[iTransact].nws_order_ref);
        }
    }
    // ================================================================= transactions  
    initTransactions() {
        this.partsTransacts = [];
        this.rowsTransacts = [];
    }
    initListParts(action) {
        this.partsTransactChoice = [];
        if (action === 'input') { // input =  back in stock : only parts taken out of stock
            for (const partSupplieItem of this.partsRequirement) {
                const partSupplieCur = JSON.parse(JSON.stringify(partSupplieItem));
                if (partSupplieCur.outputStock > 0 && partSupplieCur.outputStock > partSupplieCur.inputStock) {
                    this.partsTransactChoice.push(partSupplieCur);
                }
            }
            this.partsTransactChoice.sort((a, b) => a.brandRef.localeCompare(b.brandRef));
        }
        else { // output of stock : 
            // only parts for which the planned quantities have not been issued in full and those 
            // which have not been replaced and which are held in stock
            for (const partSupplieItem of this.partsRequirement) {
                const partSupplieCur = JSON.parse(JSON.stringify(partSupplieItem));
                if (partSupplieCur.outputStock === undefined) {
                    partSupplieCur.outputStock = 0;
                }
                if (partSupplieCur.inputStock === undefined) {
                    partSupplieCur.inputStock = 0;
                }
                if (partSupplieCur.quantity > 0 && partSupplieCur.quantity > (partSupplieCur.outputStock - partSupplieCur.inputStock)) {
                    this.partsTransactChoice.push(partSupplieCur);
                }
                if (partSupplieCur.partAdded
                    && partSupplieCur.inStock > 0) {
                    this.partsTransactChoice.push(partSupplieCur);
                }
            }
            for (const partSupplieCur of this.partsRequirement) { // disposal of replaced references
                if (!partSupplieCur.partAdded) {
                    continue;
                }
                const replaced = partSupplieCur.replacesReference.split(',');
                for (const ref of replaced) {
                    let idxItem = 0;
                    for (const item of this.partsTransactChoice) {
                        if (item.brandRef === ref) {
                            this.partsTransactChoice.splice(idxItem, 1);
                            continue;
                        }
                        idxItem++;
                    }
                }
                if (partSupplieCur.outputStock === undefined) {
                    partSupplieCur.outputStock = 0;
                }
                if (partSupplieCur.inputStock === undefined) {
                    partSupplieCur.inputStock = 0;
                }
                if (partSupplieCur.quantity > 0 && partSupplieCur.quantity > (partSupplieCur.outputStock - partSupplieCur.inputStock)) {
                    this.partsTransactChoice.push(partSupplieCur);
                }
            }
            this.partsTransactChoice.sort((a, b) => a.brandRef.localeCompare(b.brandRef));
        }
    }
    disableParts(brandRef) {
        return this.partsTransacts.some(part => part.brandRef === brandRef);
    }
    updateListParts() {
        for (const itemTransact of this.partsTransacts) {
            let idxItem = 0;
            for (const itemPart of this.partsTransactChoice) {
                if (itemPart.brandRef === itemTransact.brandRef) {
                    this.partsTransactChoice.splice(idxItem, 1);
                    break;
                }
                idxItem++;
            }
        }
    }
    addTransaction() {
        this.partsTransacts.push(this.emptyRowTransaction());
        this.rowsTransacts.push({ status: 'origin', odd: false, errorQuantity: false, errorRef: false });
        this.settingOddEven(this.rowsTransacts);
        this.ctrlImputTransacts();
    }
    removeTransaction(idxPart) {
        this.partsTransacts.splice(idxPart, 1);
        this.rowsTransacts.splice(idxPart, 1);
        // this.updateListParts();
        this.settingOddEven(this.rowsTransacts);
        this.ctrlImputTransacts();
    }
    emptyRowTransaction() {
        const partTransaction = {
            brandRef: '',
            partSupplieLabel: '',
            billingUnit: '',
            comment: '',
            infoQuantity: 0,
            inStock: 0,
            transactDate: '',
            nws_order_id: '',
            nws_order_ref: '',
            outputStock: 0,
            inputStock: 0,
        };
        return partTransaction;
    }
    inputTransactFields(origin, value, idxRow) {
        switch (origin) {
            case 'brandRef': {
                this.partsTransacts[idxRow].brandRef = value;
                for (const itemPärt of this.partsTransactChoice) {
                    if (itemPärt.brandRef === value) {
                        this.partsTransacts[idxRow].partSupplieLabel = itemPärt.partSupplieLabel;
                        this.partsTransacts[idxRow].inStock = itemPärt.inStock;
                        this.partsTransacts[idxRow].billingUnit = itemPärt.billingUnit;
                        this.partsTransacts[idxRow].partAdded = itemPärt.partAdded;
                        if (this.transactOption === 'input') {
                            this.partsTransacts[idxRow].infoQuantity = itemPärt.outputStock;
                        }
                        else {
                            this.partsTransacts[idxRow].infoQuantity = itemPärt.quantity - (itemPärt.outputStock - itemPärt.inputStock);
                        }
                        this.partsTransacts[idxRow].outputStock = 0;
                        this.partsTransacts[idxRow].inputStock = 0;
                        break;
                    }
                }
                // this.updateListParts();
                this.ctrlImputTransacts();
                break;
            }
            case 'input': {
                const fieldName = origin + '_' + idxRow;
                const valueField = CommonMethods.getNumericFieldValue(fieldName);
                if (valueField > this.partsTransacts[idxRow].infoQuantity) {
                    this.unformatNumericField(fieldName);
                    this.partsTransacts[idxRow].inputStock = 0;
                    this.ctrlImputTransacts();
                    return;
                }
                this.partsTransacts[idxRow].inputStock = valueField;
                this.partsTransacts[idxRow].outputStock = 0;
                this.ctrlImputTransacts();
                break;
            }
            case 'output': {
                const fieldName = origin + '_' + idxRow;
                const valueField = CommonMethods.getNumericFieldValue(fieldName);
                if (valueField > this.partsTransacts[idxRow].inStock) {
                    this.unformatNumericField(fieldName);
                    this.partsTransacts[idxRow].outputStock = 0;
                    this.partsTransacts[idxRow].inputStock = 0;
                    this.ctrlImputTransacts();
                    return;
                }
                if (!this.partsTransacts[idxRow].partAdded
                    && valueField > this.partsTransacts[idxRow].infoQuantity) {
                    this.unformatNumericField(fieldName);
                    this.partsTransacts[idxRow].outputStock = 0;
                    this.partsTransacts[idxRow].inputStock = 0;
                    this.ctrlImputTransacts();
                    return;
                }
                this.partsTransacts[idxRow].outputStock = valueField;
                this.partsTransacts[idxRow].inputStock = 0;
                this.ctrlImputTransacts();
                break;
            }
        }
    }
    ctrlImputTransacts() {
        let idxItem = 0;
        let nbErrors = 0;
        this.isOkToSave = false;
        if (this.rowsTransacts.length === 0) {
            return;
        }
        for (const itemRow of this.rowsTransacts) {
            itemRow.errorRef = false;
            itemRow.errorQuantity = false;
            if (idxItem > this.partsTransacts.length) {
                break;
            }
            if (this.partsTransacts[idxItem].brandRef === '' || this.partsTransacts[idxItem].brandRef === undefined) {
                itemRow.errorRef = true;
                nbErrors++;
            }
            if (this.transactOption === 'input' && this.partsTransacts[idxItem].inputStock === 0) {
                itemRow.errorQuantity = true;
                nbErrors++;
            }
            if (this.transactOption === 'output' && this.partsTransacts[idxItem].outputStock === 0) {
                itemRow.errorQuantity = true;
                nbErrors++;
            }
            idxItem++;
        }
        if (nbErrors === 0) {
            this.isOkToSave = true;
        }
    }
    // ================================================================= transactions
    verifyStockParts(workId, stdEntity) {
        this.notReferencedList = [];
        this.isNotReferenced = false;
        const messageDisplay = {
            titleBox: 'verifyStock',
            messageLabel: 'verifyStockParts',
            messageArgs: [],
            messageType: 'ERROR',
            messageDatas: undefined,
            typeDialog: 'infoProgressWks',
            actionCur: 'verifyStockParts',
            progressDeterminate: false,
        };
        // const partsRequirementTmp = this.partsRequirement[0];
        this.messageBoxDisplay(messageDisplay);
        this._wksCentralService.verifyStockParts(this.partsRequirement, stdEntity, workId, this._userService.getUserLogged().userlang)
            .subscribe(data => {
            this.closeMatDialog();
            const responseParts = data.body;
            const messageDisplay1 = {
                titleBox: 'verifyStock',
                messageLabel: 'verifyStockPartsDone',
                messageArgs: [],
                messageType: 'INFO',
                messageDatas: undefined,
                typeDialog: 'alertWks',
                actionCur: 'verifyStockPartsDone',
                progressDeterminate: false,
            };
            this.messageBoxDisplay(messageDisplay1);
            let stockError = 0;
            for (const partItem of this.partsRequirement) {
                for (const responseItem of responseParts) {
                    if (responseItem.brandRef === partItem.brandRef) {
                        partItem.stockStatus = responseItem.stockStatus;
                        partItem.nws_stock_id = responseItem.nws_stock_id;
                        partItem.inStock = responseItem.inStock;
                        partItem.minStock = responseItem.minStock;
                        if (responseItem.stockStatus === 'NOT_REFERENCED') {
                            this.notReferencedList.push(partItem);
                            this.isNotReferenced = true;
                            stockError++;
                            continue;
                        }
                        partItem.nws_order_price = responseItem.nws_order_price;
                        partItem.stockStatus = 'OK';
                        if (partItem.inStock === 0 || partItem.inStock < partItem.quantity) {
                            stockError++;
                            partItem.stockStatus = 'KO';
                        }
                        break;
                    }
                }
            }
            // const jsonParts = JSON.stringify(this.partsRequirement);
            // console.log(jsonParts);
        }, err => {
            this.closeMatDialog();
            const messageDisplay2 = {
                titleBox: 'verifyStock',
                messageLabel: 'verifyStockPartsFailed',
                messageArgs: [],
                messageType: 'ERROR',
                messageDatas: undefined,
                typeDialog: 'alertWks',
                actionCur: 'verifyStockPartsFailed',
                progressDeterminate: false,
            };
            this.messageBoxDisplay(messageDisplay2);
        });
    }
    // ========================================================== errors alerts 
    messageBoxDisplay(_messageDisplay) {
        const dialogConfig = new MatDialogConfig();
        const messageBox = this._translateService.instant(_messageDisplay.messageLabel, _messageDisplay.messageArgs);
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            id: 1,
            title: this._translateService.getTranslate(_messageDisplay.titleBox),
            typeDialog: _messageDisplay.typeDialog,
            panelClass: 'stdTheme',
            contentMessage: messageBox,
            data1: _messageDisplay.messageDatas,
            data2: '',
            actionCur: _messageDisplay.actionCur,
            progressDeterminate: _messageDisplay.progressDeterminate,
            errorsList: undefined,
            messageType: _messageDisplay.messageType
        };
        this.messageDialogRef = this._dialog.open(ModalCommonComponent, dialogConfig);
        this.messageDialogRef.afterClosed()
            .pipe(takeUntil(this.onDestroy))
            .subscribe(data => {
            if (data === 'okAction') {
                if (_messageDisplay.actionCur === 'verifyStockParts') {
                    this.endProcessFile();
                }
                if (_messageDisplay.actionCur === 'verifyStockPartsDone') {
                    this.endProcessFile();
                }
                if (_messageDisplay.actionCur === 'verifyStockPartsFailed') {
                    this.endProcessFile();
                }
                if (_messageDisplay.actionCur === 'create Part') {
                }
            }
        });
    }
    closeMatDialog() {
        this._dialog.closeAll();
        if (this._dialog.openDialogs.length > 0) {
            for (const instCur of this._dialog.openDialogs) {
                this._dialog.openDialogs.splice(0, 1);
            }
        }
        this.messageDialogRef = null;
    }
    endProcessFile() {
        this.closeMatDialog();
    }
    // serchain parsts & supplies
    openSearchModal(typeSearchOpt) {
        this.dataUpstream = {
            equipType: '',
            equipBrand: '',
            equipModel: '',
        };
        this.typeSearch = typeSearchOpt,
            this.openModal(this.searchModal);
    }
    addListSuppliesModal($event) {
        this.closeModal();
        if (typeof ($event) === 'string') {
            if ($event === 'cancel') {
                return;
            }
        }
        else {
            const partsSupplies = $event;
            for (const rowPartCur of partsSupplies) {
                const newRowPart = this.getRowPartAdded(rowPartCur);
                this.partsRequirement.push(newRowPart);
                this.rowsParts.push({ status: 'origin', odd: false, isCollapsed: true });
            }
            this.settingOddEven(this.rowsParts);
            this.notifModifValues();
        }
    }
    closeModal() {
        if (this.modalRef !== undefined) {
            this.modalRef.hide();
        }
        this.modalRef = undefined;
    }
    openModal(template) {
        this.modalRef = this.modalService.show(template, this.configModal);
    }
}
